import { ColorHelper } from '../utils/color-helpers';
import { getConfig } from '@sydle/ui-utils';
import { SydleUIConfig } from '../utils/types/sydle-ui-config.types';

/**
 * Insert style tokens into html body using package definitions
 */
function setGlobalTokens(): void {
  const sydleUiConfig = getConfig<SydleUIConfig>('sydle-ui');

  if (!sydleUiConfig) {
    return;
  }

  const primaryColor = sydleUiConfig.primaryColor;
  const accentColor = sydleUiConfig.secondaryColor;
  const globalCSSTokens = sydleUiConfig.customTokens;

  let style: { [key: string]: string } = {};

  if (primaryColor) {
    style = { ...style, '--sy-primary': primaryColor };
    const variants = ColorHelper.getColorVariations(primaryColor);
    variants.forEach((variant: { name: string; value: string }) => {
      style = { ...style, [`--sy-primary-${variant.name}`]: variant.value };
    });
  }

  if (accentColor) {
    style = { ...style, '--sy-accent': accentColor };
    const variants = ColorHelper.getColorVariations(accentColor);
    variants.forEach((variant: { name: string; value: string }) => {
      style = { ...style, [`--sy-accent-${variant.name}`]: variant.value };
    });
  }

  globalCSSTokens?.forEach((element: { token: string; value: string }) => {
    style = { ...style, [element.token]: element.value };
  });

  const styleElement = document.createElement('style');
  styleElement.innerHTML = `body ${JSON.stringify(style)?.replace(/"/g, '').replace(/,/g, ';')}`;
  document.head.appendChild(styleElement);
}

setGlobalTokens();
